export enum CompensationValidationAction {
    Store,
    Update,
}
